import React from "react";

import SectionTitle from "../Common/SectionTitle";
import Download from "../Common/Download";

//Import images
import app1 from "../../assets/images/selfcenter/app1.png";
import app2 from "../../assets/images/selfcenter/app2.png";
import app3 from "../../assets/images/selfcenter/app3.png";
import { Link } from "gatsby";
import Lightbox from "react-image-lightbox";

const images = [app1, app2, app3];

const OtherBooks = () => {
  const books = [
    {
      id: 1,
      img: app1,
      name: "个人中心",
      price: "查询个人各项基础信息",
      alt: "hr软件个人中心",
    },
    {
      id: 2,
      img: app2,
      name: "APP首页",
      price: "处理任务、消息与提醒",
      alt: "hr软件APP",
    },
    {
      id: 3,
      img: app3,
      name: "流程审批",
      price: "流程审批的办理界面",
      alt: "hr软件流程审批",
    },
  ];
  const [photoIndex, setPhotoIndex] = React.useState(0);
  const [isOpenImage, setIsOpenImage] = React.useState(false);
  return (
    <section className="section">
      <div className="container">
        <SectionTitle
          title="普通员工使用一部手机就够了"
          desc="手机APP目前主要处理员工个人事务，查询个人考勤异常、办理流程等操作"
        />
        <div className="row justify-content-center align-items-center pt-50">
          {books.map((book, i) => (
            <div key={i} className="col-lg-3 col-md-6">
              <div className="single-blog-post">
                <div className="post-image">
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsOpenImage(true);
                      setPhotoIndex(i);
                    }}
                  >
                    <img src={book.img} alt={book.alt} />
                  </Link>
                </div>

                <div className="post-content">
                  <h3>{book.name}</h3>
                  <p>{book.price}</p>
                </div>
              </div>
            </div>
          ))}
          <div className="col-lg-3 col-md-6 col-sm-6">
            <Download direction="left" />
          </div>
        </div>

        {/* Lightbox */}
        {isOpenImage && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => setIsOpenImage(false)}
            onMovePrevRequest={() =>
              setPhotoIndex((photoIndex + images.length - 1) % images.length)
            }
            onMoveNextRequest={() =>
              setPhotoIndex((photoIndex + 1) % images.length)
            }
          />
        )}
      </div>
    </section>
  );
};

export default OtherBooks;
